export default __webpack_public_path__ + "static/media/cancel.ac7d39d1.svg";